import {createVuetify, type ThemeDefinition} from "vuetify"
import '@mdi/font/css/materialdesignicons.css'
import {VBtn} from 'vuetify/components/VBtn'
import {VMaskInput} from 'vuetify/labs/VMaskInput'
import {VVideo} from 'vuetify/labs/VVideo'


const longLiveTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: "#711300",
    'on-primary': "#FFFFFF",
    secondary: "#344054",
    'on-secondary': "#FFFFFF",
    'on-background': "#191717",
    'on-surface': "#191717",
    error: "#DA291C",
    newspaper: "#D7D2CB",
    'wax-stamp': "#DA291C",
    'gray-900': "#101828",
    'gray-600': "#475467",
    'gray-700': "#344054",
    'gray-500': "#667085",
  },
}

export default createVuetify({
  components: {
    VMaskInput,
    VVideo
  },
  theme: {
    defaultTheme: 'longLiveTheme',
    themes: {
      longLiveTheme
    }
  },
  aliases: {
    VBtnPrimary: VBtn,
    VBtnSecondary: VBtn,
    VBtnTertiary: VBtn,
  },
  defaults: {
    VBtnPrimary: {
      color: "primary",
      rounded: "pill",
      size: "large",
      variant: "flat",
    },
    VBtnSecondary: {
      color: "secondary",
      size: "large",
      variant: "outlined",
      rounded: "pill",
      border: 'thin',
      class: 'bg-white'
    },
    VBtnTertiary: {
      color: "accent",
      size: "large",
      variant: "flat",
      rounded: "pill",
      class: 'v-btn-tertiary',
    },
    VTextField: {
      color: "primary",
      variant: "outlined",
      rounded: "pill",
      density: "comfortable",
      hideDetails: "auto",
    },
    VMaskInput: {
      color: "primary",
      variant: "outlined",
      rounded: "pill",
      density: "comfortable",
      hideDetails: "auto",
      returnMaskedValue: true,
    },
    VCheckbox: {
      color: "primary",
      variant: "outlined",
      rounded: "lg",
      hideDetails: "auto",
    },
    VSelect: {
      color: "primary",
      variant: "outlined",
      rounded: "pill",
      density: "comfortable",
      hideDetails: "auto",
    },
    VBtn: {
      color: "primary",
      rounded: "pill",
      size: "large",
      variant: "flat",
    },
  },
  date: {
    formats: {
      date: "MM/DD/YYYY",
      datetime: "MM/DD/YYYY HH:mm",
      time: "HH:mm",
    },
  },
  icons: {
    defaultSet: "mdi",
  }
})
